import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

const PaymentSuccess = () => {
    const [searchParams] = useSearchParams();
    const [details, setDetails] = useState({});

    useEffect(() => {
        const oid = searchParams.get("oid") || searchParams.get("OID");
        const amount = searchParams.get("amount") || searchParams.get("Amount");
        const transId =
            searchParams.get("TransId") ||
            searchParams.get("transId") ||
            searchParams.get("TransactionId");
        const date = searchParams.get("date") || new Date().toLocaleDateString("fr-FR");

        setDetails({ oid, amount, transId, date });
    }, [searchParams]);

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl overflow-hidden">
                <div className="bg-green-500 p-6 text-center">
                    <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                        <span className="text-3xl">✅</span>
                    </div>
                    <h1 className="text-2xl font-bold text-white">Paiement Réussi !</h1>
                    <p className="text-green-100 mt-1">Merci pour votre commande</p>
                </div>

                <div className="p-6 space-y-4">
                    <div className="bg-green-50 border border-green-100 rounded-lg p-4 text-center">
                        <p className="text-sm text-gray-600 mb-1">Montant Payé</p>
                        <p className="text-3xl font-bold text-green-700">
                            {details.amount ? `${Number(details.amount).toFixed(2)} MAD` : "-"}
                        </p>
                    </div>

                    <div className="space-y-3 text-sm">
                        <div className="flex justify-between py-2 border-b border-gray-100">
                            <span className="text-gray-500">Référence Commande (OID)</span>
                            <span className="font-medium text-gray-900">{details.oid || "-"}</span>
                        </div>
                        <div className="flex justify-between py-2 border-b border-gray-100">
                            <span className="text-gray-500">Transaction ID (CMI)</span>
                            <span className="font-medium text-gray-900">{details.transId || "-"}</span>
                        </div>
                        <div className="flex justify-between py-2 border-b border-gray-100">
                            <span className="text-gray-500">Date</span>
                            <span className="font-medium text-gray-900">{details.date}</span>
                        </div>
                    </div>

                    <div className="bg-blue-50 p-4 rounded-lg text-xs text-blue-700">
                        ℹ️ Un email de confirmation a été envoyé à votre adresse.
                    </div>

                    <Link
                        to="/"
                        className="block w-full bg-gray-900 text-white text-center py-3 rounded-xl font-semibold hover:bg-gray-800 transition-colors shadow-md"
                    >
                        Retour à l'accueil
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PaymentSuccess;
